// src/components/gifts/CuratedCollectionRail.jsx
import { getCategoryLabel } from "../../constants/giftCategories";

export default function CuratedCollectionRail({ sections, onOpenGift }) {
  // Pull the first item from the first 3 non-empty sections — real data,
  // no placeholders. If your backend later adds a "featured" flag this is
  // the only function that needs to change.
  const picks = sections
    .filter((s) => Array.isArray(s.gifts) && s.gifts.length > 0)
    .slice(0, 3)
    .map((s) => ({ category: s.category, gift: s.gifts[0] }));

  if (picks.length === 0) return null;

  return (
    <div className="mb-6">
      <h2 className="font-serif text-base sm:text-lg text-gray-900 dark:text-white mb-2.5 px-0.5">
        Curated for you
      </h2>

      <div className="flex gap-2.5 sm:gap-3 overflow-x-auto pb-1 snap-x snap-mandatory scrollbar-hide -mx-4 px-4 sm:mx-0 sm:px-0 sm:grid sm:grid-cols-3">
        {picks.map(({ category, gift }) => (
          <button
            key={gift._id}
            onClick={() => onOpenGift(gift)}
            className="relative flex-shrink-0 w-[150px] sm:w-auto aspect-[4/3] rounded-xl sm:rounded-2xl overflow-hidden snap-start text-left group bg-gray-100 dark:bg-gray-800"
          >
            <img
              src={gift.imageUrl}
              alt={gift.title}
              loading="lazy"
              className="absolute inset-0 w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/10 to-transparent" />
            <div className="absolute bottom-2.5 left-2.5 right-2.5 sm:bottom-3.5 sm:left-3.5 sm:right-3.5">
              <p className="text-[9px] sm:text-[10px] font-semibold uppercase tracking-wide text-white/70 mb-0.5">
                {getCategoryLabel(category)}
              </p>
              <p className="text-xs sm:text-sm font-semibold text-white leading-snug line-clamp-2">
                {gift.title}
              </p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}